// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__3MFMO","info":"Note_info__3td8q","note":"Note_note__XKalb","actions":"Note_actions__MT9su"};